<template>
  <div class="logo">
    <img :src="logo.icon" alt="" :style="inputStyle" />
  </div>
</template>

<script>
 export default {
   name: 'Logo',
   props: ['logo', 'inputStyle'],
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .logo, .logo>img{
   max-width: 100%;
   max-height: 100%;
 }
  .logo{
    text-align: center;
  }
</style>
